import { LOCAL_STORAGE_KEY_PREFIX } from "@/utilities/configurations";

interface StorageServiceInterface {
  setItem(key: string, content: React.ReactNode): any;
  getItem(key: string): any;
  removeItem(key: string): any;
  getGhost(): boolean | null;
}

const storageService: StorageServiceInterface = {
  setItem: (key: string, content: React.ReactNode) => {
    if (content) {
      if (
        key === "activeRelationshipId" ||
        key === "token" ||
        key === "ghost-role" ||
        key === "is-ghost"
      ) {
        if (
          sessionStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}is-ghost`) ===
          "true"
        ) {
          sessionStorage.setItem(
            `${LOCAL_STORAGE_KEY_PREFIX}${key}`,
            JSON.stringify(content)
          );
        } else {
          localStorage.setItem(
            `${LOCAL_STORAGE_KEY_PREFIX}${key}`,
            JSON.stringify(content)
          );
        }
      } else {
        localStorage.setItem(
          `${LOCAL_STORAGE_KEY_PREFIX}${key}`,
          JSON.stringify(content)
        );
      }
    }
  },

  getItem: (key: string) => {
    if (
      key === "activeRelationshipId" ||
      key === "token" ||
      key === "ghost-role" ||
      key === "is-ghost"
    ) {
      if (
        sessionStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}is-ghost`) === "true"
      ) {
        try {
          return JSON.parse(
            sessionStorage.getItem(
              `${LOCAL_STORAGE_KEY_PREFIX}${key}`
            ) as string
          );
        } catch (e) {
          return sessionStorage.getItem(
            `${LOCAL_STORAGE_KEY_PREFIX}${key}`
          ) as string;
        }
      } else {
        try {
          return JSON.parse(
            localStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}${key}`) as string
          );
        } catch (e) {
          return localStorage.getItem(
            `${LOCAL_STORAGE_KEY_PREFIX}${key}`
          ) as string;
        }
      }
    } else {
      return (
        JSON.parse(
          localStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}${key}`) as string
        ) || null
      );
    }
  },

  removeItem: (key: string) => {
    if (
      key === "activeRelationshipId" ||
      key === "token" ||
      key === "ghost-role" ||
      key === "is-ghost"
    ) {
      if (
        sessionStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}is-ghost`) === "true"
      ) {
        sessionStorage.removeItem(`${LOCAL_STORAGE_KEY_PREFIX}${key}`);
      } else {
        localStorage.removeItem(`${LOCAL_STORAGE_KEY_PREFIX}${key}`);
      }
    } else {
      localStorage.removeItem(`${LOCAL_STORAGE_KEY_PREFIX}${key}`);
    }
  },
  getGhost: () => {
    return JSON.parse(
      sessionStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}is-ghost`) as string
    );
  },
};

export default storageService;
